import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FileUploadModal = ({ file, onUpload, onClose }) => {
  const [caption, setCaption] = useState('');
  const [preview, setPreview] = useState(null);

  React.useEffect(() => {
    if (file && file?.type?.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader?.result);
      };
      reader?.readAsDataURL(file);
    }
  }, [file]);

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024)?.toFixed(1) + ' KB';
    return (bytes / (1024 * 1024))?.toFixed(1) + ' MB';
  };

  const getFileIcon = () => {
    if (file?.type?.startsWith('image/')) return 'Image';
    if (file?.type?.startsWith('video/')) return 'Video';
    if (file?.type?.startsWith('audio/')) return 'Music';
    if (file?.type?.includes('pdf')) return 'FileText';
    return 'File';
  };

  const handleUpload = () => {
    onUpload(file, caption);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground">Send File</h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-muted rounded transition-smooth"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-4">
          {/* File Preview */}
          <div className="border border-border rounded-lg p-4">
            {preview ? (
              <img
                src={preview}
                alt="Preview"
                className="w-full h-48 object-contain rounded"
              />
            ) : (
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center">
                  <Icon name={getFileIcon()} size={24} className="text-muted-foreground" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground truncate">{file?.name}</p>
                  <p className="text-xs text-muted-foreground">{formatFileSize(file?.size)}</p>
                </div>
              </div>
            )}
          </div>

          {/* Caption Input */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Caption (optional)
            </label>
            <textarea
              value={caption}
              onChange={(e) => setCaption(e?.target?.value)}
              placeholder="Add a caption..."
              rows={3}
              className="w-full px-3 py-2 bg-muted border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring resize-none"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-2 p-4 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleUpload}
            iconName="Send"
            className="flex-1"
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FileUploadModal;